import React from "react";
import { Card, Row, Col, Avatar } from "antd";
import { graphql, StaticQuery, Link } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/TheLayout";
import journals from "../img/journals.jpg";
const ResearchThemeCard = ({ data }) => {
  const { thumbnail, title, blurb } = data.frontmatter;
  const { fields } = data;
  return (
    <Col lg={{ span: 8 }} md={{ span: 12 }}>
      <Link to={fields.slug}>
        <Card
          hoverable
          bordered={false}
          style={{ textAlign: "center", marginBottom: "16px", height: "370px" }}
        >
          <div style={{ minHeight: "155px" }}>
            {thumbnail ? (
              <Img fixed={thumbnail.childImageSharp.fixed} />
            ) : (
              <Avatar icon="book" size={150} />
            )}
          </div>

          <h2
            style={{ marginTop: "12px", fontSize: "1.3em", color: "#474487" }}
          >
            {title}
          </h2>
          <p>{blurb}</p>
        </Card>
      </Link>
    </Col>
  );
};

const ResearchPage = () => {
  return (
    <Layout>
      <div
        style={{
          maxWidth: "80%",
          margin: "20px auto",
          textAlign: "center"
        }}
      >
        <h1 style={{ color: "#474487" }}>Research Themes</h1>
      </div>

      <StaticQuery
        query={graphql`
          query {
            allMarkdownRemark(
              filter: { frontmatter: { templateKey: { eq: "research-theme" } } }
              sort: { order: ASC, fields: [frontmatter___date] }
            ) {
              edges {
                node {
                  fields {
                    slug
                  }
                  html
                  id
                  frontmatter {
                    thumbnail {
                      childImageSharp {
                        fixed(width: 150) {
                          ...GatsbyImageSharpFixed
                        }
                      }
                    }
                    title
                    blurb
                    publications {
                      title
                      authors
                      journal
                      link
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const { edges: themes } = data.allMarkdownRemark;
          return (
            <div style={{ maxWidth: "1140px", margin: "16px auto" }}>
              <Row
                gutter={16}
                style={{ marginLeft: "unset", marginRight: "unset" }}
              >
                {themes.map(theme => (
                  <ResearchThemeCard key={theme.node.id} data={theme.node} />
                ))}
                <Col lg={{ span: 8 }} md={{ span: 12 }}>
                  <Link to="/publications">
                    <Card
                      hoverable
                      bordered={false}
                      style={{
                        textAlign: "center",
                        marginBottom: "16px",
                        height: "370px"
                      }}
                    >
                      <div style={{ minHeight: "155px" }}>
                        <img
                          src={journals}
                          alt=""
                          style={{ maxWidth: "150px" }}
                        />
                      </div>
                      <h2
                        style={{
                          marginTop: "12px",
                          fontSize: "1.3em",
                          color: "orange"
                        }}
                      >
                        Publications
                      </h2>
                      <p>
                        The results of our research get published in
                        high-impact, peer-reviewed scientific journals
                      </p>
                    </Card>
                  </Link>
                </Col>
              </Row>
            </div>
          );
        }}
      />
    </Layout>
  );
};

export default ResearchPage;
